module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("captchaimg", [["img",{"class":"captcha-img"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/templates/captchaimg.tpl
// module id = 191
// module chunks = 2